import { render, staticRenderFns } from "./WorkAPicture.vue?vue&type=template&id=66ff7c30&scoped=true"
import script from "./WorkAPicture.vue?vue&type=script&lang=js"
export * from "./WorkAPicture.vue?vue&type=script&lang=js"
import style0 from "./WorkAPicture.vue?vue&type=style&index=0&id=66ff7c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff7c30",
  null
  
)

export default component.exports